/// <reference types="./index.d.ts" />
import { useTheme } from "@mui/material";
import ImageGreen from "./accent-green.png";
import ImageWhite from "./accent-white.png";
import { TColor } from "./types";

export const VerticalLines = ({
    style,
    color = "green",
}: {
    style?: React.CSSProperties;
    color?: TColor;
}) => {
    const theme = useTheme();
    const image = color === "white" ? ImageWhite : ImageGreen;
    return (
        <div
            className="convert-me"
            style={{
                //@ts-ignore
                backgroundImage: `url("${image.src}")`,
                backgroundSize: "cover",
                position: "absolute",
                width: "100%",
                opacity: theme.palette.mode === "dark" ? 0.1 : 0.2,
                ...style,
            }}
        />
    );
};
